import { render, staticRenderFns } from "./IndexationParametersWidget.vue?vue&type=template&id=0b1ff57a&"
import script from "./IndexationParametersWidget.vue?vue&type=script&lang=js&"
export * from "./IndexationParametersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports